import {
  TABLE_PAGE_SIZE_OPTIONS,
  type UrlSyncedTablePaginationController,
} from "../../helpers/table-pagination-url";
import { TablePaginationControls } from "./table-pagination-controls";

type DynamicTablePaginationProps = {
  paginationController?: UrlSyncedTablePaginationController;
  totalItems: number;
};

export const DynamicTablePagination = ({
  paginationController,
  totalItems,
}: DynamicTablePaginationProps) => {
  if (!paginationController || totalItems <= TABLE_PAGE_SIZE_OPTIONS[0]) {
    return null;
  }

  return (
    <TablePaginationControls
      pagination={paginationController.pagination}
      firstVisibleIndex={paginationController.firstVisibleIndex}
      lastVisibleIndex={paginationController.lastVisibleIndex}
      totalItems={totalItems}
      totalPages={paginationController.totalPages}
      onPageSizeChange={paginationController.setPageSize}
      onFirstPage={paginationController.goToFirstPage}
      onPreviousPage={paginationController.goToPreviousPage}
      onNextPage={paginationController.goToNextPage}
      onLastPage={paginationController.goToLastPage}
    />
  );
};
